<template>
  <div class="min-h-screen bg-gray-50 font-sans">
    <!-- 导航菜单 -->
    <BlogHeader />
    
    <router-view/>
    <!-- 路由视图 -->
    <!-- <router-view v-slot="{ Component }">
      <transition name="fade" mode="out-in">
        <component :is="Component" />
      </transition>
    </router-view> -->
    
    <!-- 页脚 -->
    <BlogFooter />
  </div>
</template>

<script>
import BlogHeader from '@/components/BlogHeader.vue'
import BlogFooter from '@/components/BlogFooter.vue'

export default {
  name: 'BlogHome',
  components: {
    BlogHeader,
    BlogFooter
  },
  data() {
    return {
      selectedCategoryId: 1 // 默认选择全部类别（ID为1）
    }
  },
  mounted() {
    // 添加全局样式和事件监听
    this.addGlobalStyles()
    this.setupEventListeners()
  },
  beforeDestroy() {
    // 清理事件监听
    this.removeEventListeners()
  },
  methods: {
    addGlobalStyles() {
      // 添加一些全局样式
      const style = document.createElement('style')
      style.textContent = `
        /* 全局字体和基础样式 */
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');
        
        :root {
          --primary-color: #007bff;
          --primary-hover: #0056b3;
          --text-primary: #333;
          --text-secondary: #666;
          --text-muted: #999;
          --bg-light: #f8f9fa;
          --bg-white: #fff;
          --border-color: #e9ecef;
          --shadow-sm: 0 2px 10px rgba(0, 0, 0, 0.05);
          --shadow-md: 0 4px 20px rgba(0, 0, 0, 0.08);
          --shadow-lg: 0 10px 25px rgba(0, 0, 0, 0.1);
          --transition: all 0.3s ease;
        }
        
        html {
          scroll-behavior: smooth;
        }
        
        body {
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif;
          color: var(--text-primary);
          line-height: 1.6;
          margin: 0;
          padding: 0;
          background-color: var(--bg-light);
        }
        
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }
        
        a {
          color: var(--text-primary);
          text-decoration: none;
          transition: var(--transition);
        }
        
        h1, h2, h3, h4, h5, h6 {
          font-weight: 600;
          line-height: 1.3;
          color: var(--text-primary);
        }
        
        img {
          max-width: 100%;
          height: auto;
        }
        
        button {
          font-family: inherit;
          cursor: pointer;
        }
        
        input, button, textarea {
          font-family: inherit;
        }
        
        /* 滚动条样式 */
        ::-webkit-scrollbar {
          width: 8px;
          height: 8px;
        }
        
        ::-webkit-scrollbar-track {
          background: #f1f1f1;
        }
        
        ::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 4px;
        }
        
        ::-webkit-scrollbar-thumb:hover {
          background: #555;
        }
        
        /* 图片懒加载过渡效果 */
        img[loading="lazy"] {
          opacity: 0;
          transition: opacity 0.5s ease-in-out;
        }
        
        img[loading="lazy"].loaded {
          opacity: 1;
        }
      `
      document.head.appendChild(style)
      this.globalStyleElement = style
    },
    setupEventListeners() {
      // 为懒加载图片添加加载完成事件
      document.addEventListener('DOMContentLoaded', this.setupLazyLoadImages)
      window.addEventListener('scroll', this.handleScroll)
    },
    removeEventListeners() {
      if (this.globalStyleElement) {
        document.head.removeChild(this.globalStyleElement)
      }
      window.removeEventListener('scroll', this.handleScroll)
    },
    setupLazyLoadImages() {
      const lazyImages = document.querySelectorAll('img[loading="lazy"]')
      lazyImages.forEach(img => {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              img.classList.add('loaded')
              observer.unobserve(img)
            }
          })
        })
        observer.observe(img)
      })
    },
    handleScroll() {
      // 可以在这里添加滚动相关的逻辑，比如导航栏样式变化等
      const header = document.querySelector('.blog-header')
      if (header) {
        if (window.scrollY > 50) {
          header.classList.add('scrolled')
        } else {
          header.classList.remove('scrolled')
        }
      }
    }
  }
}
</script>

<style>
/* 组件特定的全局样式可以在这里添加 */
.blog-header.scrolled {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background-color: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(5px);
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.fade-in {
  animation: fadeIn 0.6s ease-out;
}

/* 路由过渡动画样式 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
  transform: translateY(20px);
}

/* 响应式断点工具类 */
@media (max-width: 1200px) {
  .container {
    max-width: 100%;
    padding: 0 20px;
  }
}

@media (max-width: 768px) {
  .container {
    padding: 0 16px;
  }
  
  body {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .container {
    padding: 0 12px;
  }
}
</style>